import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeildActivityService {

constructor(private http:HttpClient) { }


GetRecord():Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity").pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetAll():Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity/GetAll").pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetSingle(id:Number):Observable<FeildActivity_Interface>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity/GetSingle?id="+id).pipe(
    map(data=>{
      return data as FeildActivity_Interface
    })
  )
}

AddFeildActivity(model: FeildActivity_Interface):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    del:false,
    Code:model.code,
    username:'',
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/FeildActivity/Add",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

EditFeildActivity(model: FeildActivity_Interface):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    del:false,
    Code:model.code,
    username:'',
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/FeildActivity/Edit",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

DeleteFeildActivity(id:number):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/FeildActivity/Delete?id="+id).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

}
